import { addMessages } from '@hana/i18n';

// Chuỗi Tạo job (chat / nhiều booking). Mã nghiệp vụ, tên riêng, dữ liệu mẫu không dịch.
addMessages('vi', {
  "jobNew.from": "Bắt đầu từ",
  "jobNew.selPh": "Chọn…",
  "jobNew.chatMsg": "Tin nhắn từ chat Ask HANA",
  "jobNew.dupHit": "Kiểm trùng: tin nhắn khớp job đã có",
  "jobNew.noDup": "Không trùng BookingNo, HBL / MBL, container, Ref khách hay khách + tàu + POD",
  "jobNew.readCheck": "Đọc & kiểm trùng",
  "jobNew.openFilled": "Mở form điền sẵn",
  "jobNew.multi": "Đặt nhiều booking một lúc",
  "jobNew.carrierVessel": "Hãng · Tàu / chuyến",
  "jobNew.bkQty": "Số booking",
  "jobNew.attach": "Đính kèm",
  "jobNew.drop": "Kéo thả tệp vào đây",
  "jobNew.pick": "Chọn tệp",
  "jobNew.sum": "Tóm tắt job",
  "jobNew.chk": "Kiểm trước khi tạo",
  "jobNew.after": "Sau khi tạo"
});
addMessages('en', {
  "jobNew.from": "Start from",
  "jobNew.selPh": "Select…",
  "jobNew.chatMsg": "Message from Ask HANA chat",
  "jobNew.dupHit": "Duplicate check: message matches an existing job",
  "jobNew.noDup": "No match on BookingNo, HBL / MBL, container, customer ref or customer + vessel + POD",
  "jobNew.readCheck": "Read & check duplicates",
  "jobNew.openFilled": "Open prefilled form",
  "jobNew.multi": "Book several at once",
  "jobNew.carrierVessel": "Carrier · Vessel / voyage",
  "jobNew.bkQty": "Bookings",
  "jobNew.attach": "Attachments",
  "jobNew.drop": "Drag files here",
  "jobNew.pick": "Choose files",
  "jobNew.sum": "Job summary",
  "jobNew.chk": "Pre-create checks",
  "jobNew.after": "After creating"
});

addMessages('vi', { 'jobNew.saveDraft': 'Lưu nháp' });
addMessages('en', { 'jobNew.saveDraft': 'Save draft' });

addMessages('vi', {
  'jobNew.a11y1': 'Tạo job',
  'jobNew.a11y2': 'Tạo từ chat Ask HANA',
  'jobNew.a11y3': 'Giải thích: Ask HANA nhận ra ý định tạo đơn · kiểm trùng trước khi điền',
  'jobNew.a11y4': 'Ask HANA nhận ra ý định tạo đơn · kiểm trùng trước khi điền',
  'jobNew.a11y5': 'Mở hoặc gập Tin nhắn từ chat Ask HANA',
  'jobNew.a11y6': 'Tin nhắn chat',
  'jobNew.a11y7': 'Giải thích: Mỗi booking thành một job riêng, chung batch · khách, hàng, các bên lấy từ phần dưới',
  'jobNew.a11y8': 'Mỗi booking thành một job riêng, chung batch · khách, hàng, các bên lấy từ phần dưới',
  'jobNew.a11y9': 'Mở hoặc gập Đặt nhiều booking một lúc',
  'jobNew.a11y10': 'Nguồn lịch',
  'jobNew.a11y11': 'Bớt',
  'jobNew.a11y12': 'Thêm',
  'jobNew.a11y13': 'Mở hoặc gập mục form',
  'jobNew.a11y14': 'Đính kèm',
  'jobNew.a11y15': 'Giải thích: booking request, SI, hình ảnh hàng · lên thư mục chứng từ khi tạo xong',
  'jobNew.a11y16': 'booking request, SI, hình ảnh hàng · lên thư mục chứng từ khi tạo xong',
  'jobNew.a11y17': 'Mở hoặc gập Đính kèm',
  'jobNew.a11y18': 'Tóm tắt',
  'jobNew.a11y19': 'Mở hoặc gập Tóm tắt job',
  'jobNew.a11y20': 'Kiểm trước khi tạo',
  'jobNew.a11y21': 'Mở hoặc gập Kiểm trước khi tạo',
  'jobNew.a11y22': 'Sau khi tạo',
  'jobNew.a11y23': 'Mở hoặc gập Sau khi tạo',
});
addMessages('en', {
  'jobNew.a11y1': 'Create job',
  'jobNew.a11y2': 'Create from Ask HANA chat',
  'jobNew.a11y3': 'Explanation: Ask HANA detects the intent to create an order · checks duplicates before filling',
  'jobNew.a11y4': 'Ask HANA detects the intent to create an order · checks duplicates before filling',
  'jobNew.a11y5': 'Expand or collapse messages from Ask HANA chat',
  'jobNew.a11y6': 'Chat messages',
  'jobNew.a11y7': 'Explanation: Each booking becomes its own job, same batch · customer, cargo and parties come from the section below',
  'jobNew.a11y8': 'Each booking becomes its own job, same batch · customer, cargo and parties come from the section below',
  'jobNew.a11y9': 'Expand or collapse Book several at once',
  'jobNew.a11y10': 'Schedule source',
  'jobNew.a11y11': 'Less',
  'jobNew.a11y12': 'More',
  'jobNew.a11y13': 'Expand or collapse form section',
  'jobNew.a11y14': 'Attachments',
  'jobNew.a11y15': 'Explanation: booking request, SI, cargo photos · go to the document folder once created',
  'jobNew.a11y16': 'booking request, SI, cargo photos · go to the document folder once created',
  'jobNew.a11y17': 'Expand or collapse Attachments',
  'jobNew.a11y18': 'Summary',
  'jobNew.a11y19': 'Expand or collapse Job summary',
  'jobNew.a11y20': 'Pre-create checks',
  'jobNew.a11y21': 'Expand or collapse Pre-create checks',
  'jobNew.a11y22': 'After creation',
  'jobNew.a11y23': 'Expand or collapse After creation',
});
